/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { useCallback } from "react";
import { JoinRule, type Room, type RoomState } from "matrix-js-sdk";

import { useRoomState } from "./useRoomState";

/**
 * Проверяет, может ли пользователь поделиться gateway-ссылкой комнаты.
 * Для публичной комнаты приглашение не требуется, а для остальных комнат
 * пользователь должен иметь право отправлять приглашения.
 */
function canManageWithState(room: Room, state: RoomState): boolean {
  return (
    state.getJoinRule() === JoinRule.Public ||
    room.canInvite(room.client.getSafeUserId())
  );
}

/** Проверяет текущее право пользователя поделиться gateway-ссылкой комнаты. */
export function canManageRoomInviteLink(room: Room): boolean {
  return canManageWithState(room, room.currentState);
}

/** Реактивно отслеживает право пользователя поделиться gateway-ссылкой. */
export function useCanManageRoomInviteLink(room: Room): boolean {
  return useRoomState(
    room,
    useCallback((state) => canManageWithState(room, state), [room]),
  );
}
